import {type SocketDataTypes} from '../../../../shared/SocketDataTypes.ts'
import {ArrayUtils} from '../../../../shared/utils/ArrayUtils.ts'
import {CA} from '../../../shared/scripts/analytics/Analytics.ts'
import {UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController.ts'
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend.ts'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables.ts'
import {UITopNotificationView} from './UITopNotificationView.ts'
import {getHomepageUrlWithParameter, navigateToPage, throttleUserAction} from '../../../shared/scripts/ui_utils/ClientUtils.ts'
import {type TranslationObject} from '@colonist/i18n'
import {uiGameManager} from '../../../shared/scripts/EntryShared.ts'
import {UIUrlParameterNames} from '../../../shared/scripts/ui_html/UIUrlController.ts'

export class UITopNotificationController {
    private static readonly gameIds: string[] = []
    private static readonly rejectedGameIds: string[] = []
    private static readonly views: UITopNotificationView[] = []

    static show(text: TranslationObject, type: UITopNotificationType, buttonText?: TranslationObject, action?: () => void, removeAction?: () => void, showCloseButton: boolean = true, duration?: number) {
        this.views.push(new UITopNotificationView(text, type, buttonText, action, removeAction, showCloseButton, duration))
    }

    static showGames(games: SocketDataTypes.UserGamesData[]) {
        for(const game of games) {
            if(this.gameIds.includes(game.id)) continue
            if(this.rejectedGameIds.includes(game.id)) continue
            this.gameIds.push(game.id)

            const disconnectTranslation: TranslationObject = game.disconnected ? {
                key: 'strings:homePage.notifications.disconnectedFromGame',
                options: {
                    context: UIUtilsEjsVariables.isUserOnDiscord ? 'discord' : undefined,
                    playerCount: game.playerCount,
                    gameId: UIUtilsEjsVariables.isUserOnDiscord ? undefined : game.id,
                },
            } : {
                key: 'strings:homePage.notifications.activeGame',
                options: {
                    context: UIUtilsEjsVariables.isUserOnDiscord ? 'discord' : undefined,
                    playerCount: game.playerCount,
                    gameId: UIUtilsEjsVariables.isUserOnDiscord ? undefined : game.id,
                },
            }

            const reconnectAction = uiGameManager != undefined
                ? throttleUserAction(() => SocketLobbySend.reconnectGame(game.id, CA.Label.ClickedReconnectGame))
                : () => navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.ReconnectGame, game.id))

            this.show(disconnectTranslation, UITopNotificationType.Reconnect, {key: 'strings:homePage.notifications.reconnect'}, reconnectAction, () => {
                ArrayUtils.removeElementFromArray(this.gameIds, game.id)
                this.rejectedGameIds.push(game.id)
            })
        }
    }

    static removeDisconnectBanners() {
        this.removeBanners(UITopNotificationType.Reconnect)
    }

    static removeSocketErrorBanners() {
        this.removeBanners(UITopNotificationType.SocketError)
    }

    private static removeBanners(type: UITopNotificationType) {
        for(const view of this.views) {
            if(view.type != type) continue
            view.hide()
            ArrayUtils.removeElementFromArray(this.views, view)
        }
    }
}
